import React from 'react'
import { LinearGradient } from 'expo-linear-gradient'
import ShimmerPlaceHolder, { ShimmerPlaceholderProps } from 'react-native-shimmer-placeholder'

import Styles from './style'

const Shimmer = (props: ShimmerPlaceholderProps) => {
  const { ...butter } = props
  return (
    <ShimmerPlaceHolder
      LinearGradient={LinearGradient}
      shimmerColors={Styles.shimmerColors}
      {...butter}
    />
  )
}

export default Shimmer
